<app-admin-header [header]="header" [breadcrumbs]="breadcrumbs"></app-admin-header>

<!-- Main View -->
<section class="container my-5" [hidden]="addTrainer">
  <p-selectButton class="v4-active" styleClass="d-flex justify-content-center my-3" (onChange)="getTrainers()"
    [options]="tabs" [(ngModel)]="typeFlag" [multiple]="false" optionLabel="name" optionValue="value"></p-selectButton>

  <div class="d-flex justify-content-end my-2">
    <button class="v4-btn-every py-2 mb-2" [hidden]="typeFlag == 'External'" (click)="addTrainer = true">
      <i class="pi pi-plus v4-ml-2"></i>{{ "Add trainer" | translator }}
    </button>
  </div>
  <div class="d-flex justify-content-center my-2 w-100 mb-4" *ngIf="typeFlag == 'External'">
    <p-dropdown class="ppp-dropdown w-100" [options]="companyData" [filter]="true" filterBy="name" (onChange)="getTrainers()"
      placeholder="{{'Select company' | translator}}" [(ngModel)]="companyFilter" optionLabel="name"
      inputId="float-label"></p-dropdown>
    <div class="v4-rotate">
      <i pTooltip="{{ 'Reset' | translator }}" (click)="refreshFilters()" tooltipPosition="top"
        class="fa-solid fa-arrows-rotate mx-3 color-grey"></i>
    </div>
  </div>

  <div class="d-flex justify-content-center my-2" *ngIf="skeleton">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <section [hidden]="skeleton">
    <app-no-data [hidden]="trainerData.length > 0"></app-no-data>
    <p-table [hidden]="trainerData.length <= 0" styleClass="custom-table" [value]="trainerData" dataKey="code"
      [paginator]="true" [scrollable]="true" [rows]="10" [selectionPageOnly]="true"
      [tableStyle]="{ 'min-width': '40rem' }">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ "the name" | translator }}</th>
          <th>{{ "Email" | translator }}</th>
          <th>{{ "Gender" | translator }}</th>
          <th>{{ "National ID" | translator }}</th>
          <th>{{ "Phone Number" | translator }}</th>
          <th *ngIf="typeFlag == 'Internal'">{{ "Action" | translator }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-trainer>
        <tr>
          <td>
            {{ trainer.name.first }} {{ trainer.name.middle }}
            {{ trainer.name.last }}
          </td>
          <td>{{ trainer.email }}</td>
          <td>{{ trainer?.gender }}</td>
          <td>{{ trainer?.national_id }}</td>
          <td>{{ trainer?.phone }}</td>
          <td>
            <div class="d-flex">
              <span pTooltip="{{ 'Remove trainer' | translator }}" tooltipPosition="top"
                class="tabel-circle-btn d-flex align-items-center" [hidden]="typeFlag == 'External'">
                <i (click)="confirmDeleteTrainer(trainer?._id)" class="fa fa-times"></i>
              </span>
              <span pTooltip="{{ 'View Rating Graph' | translator }}" tooltipPosition="top"
                class="tabel-circle-btn d-flex align-items-center">
                <i (click)="setratingUserID(trainer?._id)" class="pi pi-chart-bar"></i>
              </span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </section>
</section>


<!-- assNewTrainers -->
<!-- Add trainers -->
<section [hidden]="!addTrainer">
  <app-assign-users [userFetchUrl]="'user/get'" [selectionData]="[]" (selectedUsersList)="assNewTrainers($event)"
    [query]="{
      'externalUser.status': { $ne: true },
      'externalUser.role': { $nin: ['trainer', 'coordinator'] }
    }" *ngIf="addTrainer">
  </app-assign-users>
</section>

<p-dialog [blockScroll]="true" [draggable]="false" header="{{ 'Average Rating' | translator }}"
  [(visible)]="showRatingGraph" [modal]="true" [style]="{ width: '95vw', maxWidth: '1200px' }" [draggable]="false"
  [resizable]="false" (onHide)="ratingUserID = '' ">
  <ng-container *ngIf="ratingUserID != ''">
    <app-rating-graph [ratingUserID]="ratingUserID"></app-rating-graph>
  </ng-container>
  <ng-template pTemplate="footer">
  </ng-template>
</p-dialog>

<p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>

<app-footer></app-footer>